import axiosInstance from './axiosInstance';

const getPrivateCategories = async ({ token }) => {
  try {
    const response = await axiosInstance.post(
      '/privatecategories',
      {},
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export {getPrivateCategories};